import React from 'react';
import {
  Box,
  Typography,
  TextField
} from '@mui/material';

interface ProjectTitleInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  helperText?: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
}

const ProjectTitleInput: React.FC<ProjectTitleInputProps> = ({
  value,
  onChange,
  label = "QI Project Title",
  helperText = "A short, clear project title summarizing the quality improvement focus in line with the priority problem (e.g., \"Improving Timely Referral by CHPs\").",
  placeholder = "Enter your QI project title",
  required = true,
  error = false,
  errorMessage = ""
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1, mb: 0.5 }}>
        {helperText}
      </Typography>
      <TextField
        fullWidth
        label={label}
        name="projectTitle"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        error={error}
        helperText={error ? errorMessage : ''}
        margin="normal"
      />
    </Box>
  );
};

export default ProjectTitleInput;
